module.exports = __webpack_public_path__ + "static/gallery_yarra_3-a78ab6f44c9c700643efd1eda5967c1a.jpg";